"use strict";
/**
 * Implements JSON CRDT Patch "binary" serialization format, which is
 * the most compact binary encoding format.
 *
 * Usage:
 *
 * ```ts
 * const encoded = encode(patch);
 * const decoded = decode(encoded);
 * ```
 *
 * @module json-crdt-patch/codec/binary
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./Encoder"), exports);
tslib_1.__exportStar(require("./Decoder"), exports);
tslib_1.__exportStar(require("./shared"), exports);
